export default {"src":"/_next/static/media/multiCurrencyAccept.fda5cb09.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};